import { queryClient } from '@integrations/reactquery';

/**
 * Simple utility function to get a query from the queryClient outside of the component tree.
 * This is useful for getting query data in utility functions or other places where you don't have access to the component tree.
 *
 * You would only use this if your key has more than one match potentia.
 * Split.io is a good example of this because we add a time at the end, and we
 * don't know what that time is.
 *
 * @param {any[]} keyPath
 * @returns {any}
 */
const getQueryOutsideTree = (keyPath: any[]): any => {
  const allQueries = queryClient.getQueriesData({
    stale: false,
    exact: false,
  });

  const matchedQuery = allQueries.find(query => keyPath.every(key => query[0].includes(key)));
  return matchedQuery ? matchedQuery[1] : null;
};

export default getQueryOutsideTree;
